class SteelhomeComboProduct extends HTMLElement {
  connectedCallback() {
    this.purchaseSwatches = [...this.querySelectorAll('[data-purchase-color]')];
    this.previewSwatches = [...this.querySelectorAll('[data-preview-color]')];
    this.variantInput = this.querySelector('[name="id"]');
    this.price = this.querySelector('[data-product-price]');
    this.colorName = this.querySelector('[data-color-name]');
    this.variants = JSON.parse(this.querySelector('[data-variants]')?.textContent || '[]');
    this.purchaseSwatches.forEach((button) => button.addEventListener('click', () => this.selectPurchaseColor(button)));
    this.previewSwatches.forEach((button) => button.addEventListener('click', () => this.selectPreviewColor(button)));
  }
  showImage(index) {
    this.galleryIndex = (index + this.stageImages.length) % this.stageImages.length;
    this.stageImages.forEach((image, i) => image.classList.toggle('is-active', i === this.galleryIndex));
    this.thumbs.forEach((button, i) => button.classList.toggle('is-active', i === this.galleryIndex));
  }
  startGallery() {
    clearInterval(this.galleryTimer);
    if (this.stageImages.length > 1 && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.galleryTimer = setInterval(() => this.showImage(this.galleryIndex + 1), 4500);
    }
  }
  enableGallerySwipe() {
    const stage = this.querySelector('.shp-stage');
    if (!stage) return;
    let startX = 0;
    stage.addEventListener('pointerdown', (event) => {
      startX = event.clientX;
      clearInterval(this.galleryTimer);
      stage.setPointerCapture?.(event.pointerId);
    });
    stage.addEventListener('pointerup', (event) => {
      const distance = event.clientX - startX;
      if (Math.abs(distance) > 40) this.showImage(this.galleryIndex + (distance < 0 ? 1 : -1));
      this.startGallery();
    });
    stage.addEventListener('pointercancel', () => this.startGallery());
  }
  selectPurchaseColor(button) {
    this.purchaseSwatches.forEach((item) => item.classList.toggle('is-active', item === button));
    if (this.colorName) this.colorName.textContent = button.dataset.label;
    const match = this.variants.find((variant) => variant.options.some((option) => option.toLowerCase().includes(button.dataset.match)));
    if (match && this.variantInput) {
      this.variantInput.value = match.id;
      if (this.price) this.price.textContent = this.formatMoney(match.price);
    }
  }
  selectPreviewColor(button) {
    const color = button.dataset.color;
    this.previewSwatches.forEach((item) => item.classList.toggle('is-active', item === button));
    const previewName = this.querySelector('[data-preview-color-name]');
    if (previewName) previewName.textContent = button.dataset.label;
    this.querySelectorAll('[data-color-image]').forEach((image) => { image.src = image.dataset[color]; });
  }
  formatMoney(cents) {
    return new Intl.NumberFormat(document.documentElement.lang || 'es', {
      style: 'currency',
      currency: this.dataset.currency || 'COP'
    }).format(cents / 100);
  }
}
if (!customElements.get('steelhome-combo-product')) customElements.define('steelhome-combo-product', SteelhomeComboProduct);
